export const formStates = {
  INITIAL: '',
  LOADING: 'LOADING',
  MISSING_TOKEN: 'MISSING_TOKEN',
  INVALID_TOKEN: 'INVALID_TOKEN',
  PASSWORD_UPDATED: 'PASSWORD_UPDATED',
};
